import {
  closest,
  isElement,
} from '../../domop';
import {
  getCursorPositionFromEvent,
} from '../../highlight';
import TOUCHEND from './actions/TOUCHEND';
import TOUCHMOVE from './actions/TOUCHMOVE';
import TOUCHSTART from './actions/TOUCHSTART';

const ignore = (e: Event) => {
  const el: any = e.srcElement || e.target;
  if (isElement(el) && closest(el, null, `#ls-userdata`)) {
    // whoops, ignore the ones on our UI
    return true;
  }
  return false;
};

export default (store: any) => {
  let _touchId: number;
  document.addEventListener('mousedown', (e: MouseEvent) => {
    if (ignore(e)) { return; }
    const pos = getCursorPositionFromEvent(e, _touchId) || getCursorPositionFromEvent(e, null);
    if (!pos) { return; }
    const { x, y, touchID } = pos;
    _touchId = touchID;
    store.dispatch(TOUCHSTART({}));
    store.dispatch(TOUCHMOVE({ x, y }));
  }, true);
  document.addEventListener('mousemove', (e: MouseEvent) => {
    if (ignore(e)) { return; }
    const pos = getCursorPositionFromEvent(e, _touchId);
    if (!pos) { return; }
    const { x, y, touchID } = pos;
    _touchId = touchID;
    store.dispatch(TOUCHMOVE({ x, y }));
  }, true);
  document.addEventListener('mouseup', (e: MouseEvent) => {
    if (ignore(e)) { return; }
    const pos = getCursorPositionFromEvent(e, _touchId);
    if (!pos) { return; }
    const { x, y, touchID } = pos;
    _touchId = touchID;
    store.dispatch(TOUCHMOVE({ x, y }));
    store.dispatch(TOUCHEND({}));
  }, true);
  document.addEventListener('touchstart', (e: MouseEvent) => {
    if (ignore(e)) { return; }
    const pos = getCursorPositionFromEvent(e, _touchId) || getCursorPositionFromEvent(e, null);
    if (!pos) { return; }
    const { x, y, touchID } = pos;
    _touchId = touchID;
    store.dispatch(TOUCHSTART({}));
    store.dispatch(TOUCHMOVE({ x, y }));
  }, true);
  document.addEventListener('touchmove', (e: MouseEvent) => {
    if (ignore(e)) { return; }
    const pos = getCursorPositionFromEvent(e, _touchId);
    if (!pos) { return; }
    const { x, y, touchID } = pos;
    _touchId = touchID;
    store.dispatch(TOUCHMOVE({ x, y }));
  }, true);
  document.addEventListener('touchend', (e: MouseEvent) => {
    if (ignore(e)) { return; }
    const pos = getCursorPositionFromEvent(e, _touchId);
    if (!pos) { return; }
    const { x, y, touchID } = pos;
    _touchId = touchID;
    store.dispatch(TOUCHMOVE({ x, y }));
    store.dispatch(TOUCHEND({}));
  }, true);

  return (next: any) => (action: any) => next(action);
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/finger/middleware.tsx